"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEngine = createEngine;
const aim_1 = require("./aim");
const camera_1 = require("./camera");
const coordinates_1 = require("./coordinates");
const localization_1 = require("./localization");
const flight_1 = require("./flight");
const reconstruct_1 = require("./reconstruct");
const trainer_1 = require("./trainer");
const DEFAULT_AIM_TOLERANCE = 0.005; // m
/**
 * An engine for one profile. It keeps no state between calls: every call
 * takes the trainer's pose and returns fresh results.
 */
function createEngine(profile, options = {}) {
    const kernel = (0, flight_1.createFlight)(profile, {
        integrator: options.integrator,
        timeStep: options.timeStep,
        spinModel: options.spinModel,
    });
    const { spinModel } = kernel;
    const aim = (0, aim_1.createAimer)(profile, kernel, {
        tolerance: options.aimTolerance ?? DEFAULT_AIM_TOLERANCE,
        peakHeight: options.peakHeight ?? "apex",
    });
    const reconstruct = (0, reconstruct_1.createReconstructor)(profile, kernel, {
        tolerance: options.aimTolerance ?? DEFAULT_AIM_TOLERANCE,
    });
    const { mechanism, geometry } = profile.trainer;
    const { venue } = profile;
    return {
        profile,
        launchPoint: (pose, pitch = 0, yaw = 0) => (0, trainer_1.launchPoint)(profile.trainer.geometry, pose, pitch, yaw),
        launch: (pose, launch, flightOptions) => kernel.fly((0, trainer_1.release)(profile, pose, launch, spinModel), flightOptions),
        launchMotors: (pose, pitch, yaw, rpms, flightOptions) => {
            const { speed, spin } = mechanism.fromMotors(rpms);
            return kernel.fly((0, trainer_1.release)(profile, pose, { pitch, yaw, speed, spin }, spinModel), flightOptions);
        },
        aim,
        reconstruct,
        release: (pose, launch) => {
            const { origin, velocity, pitch, yaw, deflection } = (0, trainer_1.release)(profile, pose, launch, spinModel);
            return { origin, velocity, pitch, yaw, deflection };
        },
        armAngle: (headHeight) => (0, camera_1.armAngle)(geometry, headHeight),
        camera: (pose, keep) => (0, camera_1.camera)(profile, pose, keep),
        poseFromCamera: (localized) => (0, camera_1.poseFromCamera)(profile, localized),
        headHeightForCamera: (height) => (0, camera_1.headHeightForCamera)(geometry, height),
        headHeightForLaunch: (height) => (0, camera_1.headHeightForLaunch)(geometry, height),
        localizationHeadHeight: (localized, point, clearanceFeet) => (0, localization_1.localizationHeadHeight)(profile, localized, point, clearanceFeet),
        localizationNetClearance: (trainerY) => (0, localization_1.localizationNetClearance)(venue, trainerY),
        toLocalization: (p) => (0, coordinates_1.toLocalization)(venue, p),
        fromLocalization: (p) => (0, coordinates_1.fromLocalization)(venue, p),
        fromTrainerFrame: coordinates_1.fromTrainerFrame,
        toTrainerFrame: coordinates_1.toTrainerFrame,
        referencePoint: (name) => (0, localization_1.referencePoint)(venue, name),
        stroke: (origin, velocity, spin, flightOptions) => kernel.fly((0, trainer_1.strokeRelease)(origin, velocity, spin, spinModel), { ...flightOptions, stopOutOfBounds: false }),
    };
}
